import React from "react";
import AddIcon from "@mui/icons-material/Add";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

const Support: React.FC = () => {
  return (
    <div className="support-center">
      <h2 className="section-title">Support Center Section:</h2>

      <div className="support-card">
        <h3 className="title">Support Center</h3>
        <p className="subtitle">Get help and find answers to your questions</p>

        {/* Stats */}
        <div className="stats-grid">
          <div className="stat-box">
            <MailOutlineIcon className="icon" />
            <h4>Active Tickets</h4>
            <p className="count">0</p>
            <span className="desc">Open support requests</span>
          </div>

          <div className="stat-box">
            <CheckCircleOutlineIcon className="icon" />
            <h4>Resolved</h4>
            <p className="count">0</p>
            <span className="desc">Completed tickets</span>
          </div>

          <div className="stat-box">
            <AccessTimeIcon className="icon" />
            <h4>Avg Response Time</h4>
            <p className="count">~2h</p>
            <span className="desc">Support team response</span>
          </div>
        </div>

        {/* Ticket Actions */}
        <div className="ticket-actions">
          <div className="create-ticket">
            <AddIcon />
            <div>
              <h4>Create New Ticket</h4>
              <p>Get help with a specific issue</p>
            </div>
          </div>

          <div className="view-tickets">
            <MailOutlineIcon />
            <div>
              <h4>View All Tickets</h4>
              <p>Check status and replies</p>
            </div>
          </div>
        </div>

        {/* Quick Help */}
        <div className="quick-help">
          <h4>Quick Help Resources</h4>
          <div className="help-grid">
            <div className="help-item">
              <MenuBookIcon />
              <div>
                <h5>Knowledge Base</h5>
                <p>Browse articles and guides</p>
              </div>
            </div>
            <div className="help-item">
              <PlayCircleOutlineIcon />
              <div>
                <h5>Video Tutorials</h5>
                <p>Learn with easy step-by-step videos</p>
              </div>
            </div>
            <div className="help-item">
              <MailOutlineIcon />
              <div>
                <h5>Email Support</h5>
                <p>support@bouteek.io</p>
              </div>
            </div>
            <div className="help-item">
              <PhoneInTalkIcon />
              <div>
                <h5>Phone Support</h5>
                <p>+971 4 444 3333</p>
              </div>
            </div>
          </div>
        </div>

        {/* FAQ */}
        <div className="faq-section">
          <h4>Frequently Asked Questions</h4>
          <details>
            <summary>How do I update my product listings?</summary>
            <p>You can edit your listings directly from your dashboard.</p>
          </details>
          <details>
            <summary>When will I receive my payout?</summary>
            <p>Payouts are processed weekly based on your selected plan.</p>
          </details>
          <details>
            <summary>How do I change my shipping settings?</summary>
            <p>Go to Settings → Shipping to update options.</p>
          </details>
          <details>
            <summary>What documents do I need to upload?</summary>
            <p>Valid ID and business verification documents are required.</p>
          </details>
        </div>
      </div>

      <div className="ai-insights">
        <h4>AI Insights:</h4>
        <p>Coming soon...</p>
      </div>
    </div>
  );
};

export default Support;
